import {
  useMoveAllCollectionSharesMutation,
  MoveAllCollectionSharesMutation,
  MoveAllCollectionSharesMutationVariables,
  MutationTuple,
} from '@sketch/gql-types'
import {
  removeCollectionFromProjectCollections,
  removeCollectionFromProjectCollectionsForSelect,
  transferAllShares,
} from './utils'

interface UseMoveAllCollectionSharesProps {
  onCompleted?: (data: MoveAllCollectionSharesMutation) => void
}

export const useMoveAllCollectionShares = ({
  onCompleted,
}: UseMoveAllCollectionSharesProps): MutationTuple<
  MoveAllCollectionSharesMutation,
  MoveAllCollectionSharesMutationVariables
> => {
  const [mutation, opts] = useMoveAllCollectionSharesMutation({
    onCompleted,
    onError: 'show-toast',
  })

  const mutationWithCacheUpdate: typeof mutation = (options = {}) => {
    const { originIdentifier, removeCollection = false } =
      options.variables ?? {}

    return mutation({
      ...options,
      update: (cache, { data }) => {
        if (!data || !originIdentifier) {
          return
        }

        const {
          targetIdentifier,
          projectIdentifier,
        } = data.moveAllCollectionShares

        if (targetIdentifier) {
          transferAllShares({
            cache,
            projectIdentifier,
            originIdentifier,
            targetIdentifier,
          })
        }

        if (removeCollection) {
          removeCollectionFromProjectCollections({
            cache,
            projectIdentifier,
            collectionIdentifier: originIdentifier,
          })
          removeCollectionFromProjectCollectionsForSelect({
            cache,
            projectIdentifier,
            collectionIdentifier: originIdentifier,
          })
        }
      },
    })
  }

  return [mutationWithCacheUpdate, opts]
}
